import { Component, forwardRef, OnInit, Input } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { UtilsService } from '../../../../services/utils.service'

@Component({
    selector: 'app-currency-input',
    templateUrl: './currency-input.component.html',
    styleUrls: ['./currency-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CurrencyInputComponent),
            multi: true,
        },
    ],
})
export class CurrencyInputComponent implements OnInit, ControlValueAccessor {
    @Input() label = ''
    @Input() id = ''
    @Input() control!: any
    @Input() isReadOnly = false
    @Input() isRequired = false
    @Input() fieldConfigs: any = {
        currencyOptions: null,
        hideLabel: false,
        placeholder: '',
        center: false,
    }
    @Input() customStyle = {}
    @Input() successFeedback = false
    @Input() variant: 'inline' | 'default' = 'default'

    constructor(private readonly utils: UtilsService) {}

    innerValue: any

    public controlName = ''

    ngOnInit(): void {
        this.controlName =
            this.utils.stringToKebabCase(this.utils.getControlName(this.control) ?? '') + '-input'
    }

    get value() {
        return this.innerValue
    }

    set value(newValue) {
        if (newValue !== this.value) {
            this.innerValue = newValue
            this.onChanged(newValue)
        }
    }

    onChanged: (value: any) => void = () => {}

    onTouched: () => void = () => {}

    writeValue(value: string): void {
        this.value = value
    }

    registerOnChange(fn: any): void {
        this.onChanged = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isReadOnly = isDisabled
    }
}
